import { Alert, Snackbar, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { hideSnackbar } from "../app/slices/commonSlice";
import BreadCrumbs from "./breadcrumbs";
import Footer from "./footer/footer";
import Navigation from "./navigation/navigation";

const MainLayout = ({ children }) => {
  const dispatch = useDispatch();
  const { snackbar } = useSelector(({ common }) => common);

  return (
    <div className="main">
      <Navigation />
      <div className="content-body">
        <div className="padded-content">
          <BreadCrumbs />
          {/* <SearchBar /> */}
          <main>{children}</main>
        </div>
        <Footer />
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={snackbar.timeout}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => {
          dispatch(hideSnackbar());
        }}
      >
        <Alert
          onClose={() => {
            dispatch(hideSnackbar());
          }}
          severity={snackbar.type}
        >
          <Typography className="snackbar-text">{snackbar.message}</Typography>
        </Alert>
      </Snackbar>
    </div>
  );
};

export default MainLayout;
